<template>
  <header id="navbar">
    <div id="navbar-container" class="boxed">
      <div class="navbar-header">
        <router-link to="/dashboard" class="navbar-brand" tag="a">
          <img src="../assets/logo.png" class="brand-icon" />
        </router-link>
      </div>

      <div class="navbar-content">
        <ul class="nav" v-if="!siderbar">
          <li class="tgl-menu-btn text-main">
            <h3>iData数据管理平台</h3>
          </li>
        </ul>
        <ul class="nav" v-else>
          <li
            class="tgl-menu-btn text-main"
            v-for="item in modules"
            :key="item.id"
          >
            <a
              :href="item.url"
              :class="{
                active: $route.meta.module_name == item.url.split('/')[1],
              }"
              >{{ item.name }}</a
            >
          </li>
        </ul>
      </div>
      <div class="navbar-right" v-if="user.name && $route.path != '/login'">
        <ul class="nav navbar-top-links">
          <li id="dropdown-user" class="dropdown">
            <span
              href="#"
              data-toggle="dropdown"
              class="dropdown-toggle text-right"
              aria-expanded="false"
            >
              <img
                src="../assets/images/avatar.png"
                class="img-circle img-xs"
              />
              <!-- <i class="ion-person"></i> -->
              <!-- <span class="user-name"> {{ user.name }}</span> -->
            </span>
            <div
              class="dropdown-menu dropdown-menu-sm dropdown-menu-right panel-default"
              style=""
            >
              <ul class="head-list">
                <li>
                  <!-- <a data-target="#user-edit-modal" data-toggle="modal" class="pointer"> -->
                  <router-link to="/users/profile">
                    <i class="ion-settings"></i> 修改资料
                  </router-link>
                </li>
                <li>
                  <a @click="handleLogout" class="pointer"
                    ><i class="ion-arrow-left-a"></i> 退出</a
                  >
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </header>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { getUserFunctionModules } from '@/service/getData'

export default {
  props: {
    siderbar: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      modules: [],
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    user() {
      return this.userInfo
    },
  },
  created() {
    this.getUserFunctionModules()
  },
  methods: {
    ...mapMutations(['LOGOUT']),
    async handleLogout() {
      this.LOGOUT()
      this.$router.push('/login')
    },
    async getUserFunctionModules() {
      let res = await getUserFunctionModules()
      this.modules = res.data
    },
  },
}
</script>